import React from 'react';

import {hooks} from '../hooks';
import {custom} from '../custom';
import {theme} from '../constants';
import {product} from '../product';
import {ProductType} from '../types';

type Props = {item: ProductType; containerStyle?: any; isLast?: boolean};

export const WishlistItem: React.FC<Props> = ({
  item,
  isLast,
  containerStyle,
}): JSX.Element => {
  const navigate = hooks.useAppNavigate();

  return (
<div className="w-full px-2">
  <div
    className="flex w-full border-b pb-2 mb-2 items-start"
    style={{
      borderBottom: isLast ? 'none' : `1px solid ${theme.colors.aliceBlue2}`,
    }}
  >
    {/* تصویر سمت راست */}
    <div className="w-24 h-24  overflow-hidden flex-shrink-0">
      <custom.ImageBackground
        imageUrl={item.image}
        style={{
          width: '100%',
          height: '100%',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
      </custom.ImageBackground>
    </div>

    {/* اطلاعات محصول */}
    <div className="flex-grow pr-3 flex flex-col justify-between">
      <h6
        className="text-sm font-normal leading-5 mb-1 text-gray-800"
        style={{ ...theme.fonts.Mulish_400Regular }}
      >
        {item.title}
      </h6>
      <product.ProductPrice item={item} containerStyle={{ marginBottom: 6 }} />
    </div>

    {/* آیکن‌ها */}
    <div className="flex flex-col items-center justify-between pr-1">
      <product.ProductInWishlist
        item={item}
        version={2}
        style={{ marginBottom: 6 }}
      />
      <product.ProductInCart
        item={item}
        version={2}
        style={{ marginTop: 6 }}
      />
    </div>
  </div>
</div>
  );
};
